import { isSelect, isInput, hasValue, change } from "./input";
export const toCiIso = (address) => {
    if (/^GY/.test(address.postcode))
        return "GG";
    if (/^JE/.test(address.postcode))
        return "JE";
    return null;
};
const UK = "United Kingdom";
const IOM = "Isle of Man";
const EN = "England";
const SC = "Scotland";
const WA = "Wales";
const NI = "Northern Ireland";
const CI = "Channel Islands";
export const toIso = (address) => {
    const country = address.country;
    if (country === EN)
        return "GB";
    if (country === SC)
        return "GB";
    if (country === WA)
        return "GB";
    if (country === NI)
        return "GB";
    if (country === IOM)
        return "IM";
    if (country === CI)
        return toCiIso(address);
    return null;
};
export const toCountry = (address) => {
    const country = address.country;
    if (country === EN)
        return UK;
    if (country === SC)
        return UK;
    if (country === WA)
        return UK;
    if (country === NI)
        return UK;
    if (country === IOM)
        return IOM;
    if (country === CI) {
        const iso = toCiIso(address);
        if (iso === "GG")
            return "Guernsey";
        if (iso === "JE")
            return "Jersey";
    }
    return null;
};
export const updateCountry = (select, address) => {
    if (!select)
        return;
    if (isSelect(select)) {
        const iso = toIso(address);
        if (hasValue(select, iso))
            change({ e: select, value: iso });
        const bcc = toCountry(address);
        if (hasValue(select, bcc))
            change({ e: select, value: bcc });
    }
    if (isInput(select)) {
        const bcc = toCountry(address);
        change({ e: select, value: bcc });
    }
};
